module.exports = __webpack_public_path__ + "img/Group 26993@2x.fd682b81.png";